import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'

// MUI License
import {LicenseInfo} from '@mui/x-license-pro'

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 *
 * @see https://github.com/axios/axios#interceptors
 */

Chart.register(...registerables)

// Set your MUI license key
LicenseInfo.setLicenseKey(
  'c8724662502755e53525efe131da6a02Tz03MjAzOSxFPTE3MjI3MDI0MDAwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI='
)

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <MetronicI18nProvider>
        <AppRoutes />
      </MetronicI18nProvider>
    </QueryClientProvider>
  )
}
